import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Field } from 'redux-form';

import AnovaRowData from './RawData/Component';
import Input from 'components/Input';
import AnovaSummaryStatistics from './SummaryStatistics/Component';
import { RadioButtonsGroup } from 'scenes/InferentialStatistics/SettingsForm/RadioButton/Component';

import { getNumberOfGroups, isAnovaModeDatasetContainsRawData, isNumericalAndCategoricalAnovaChosen } from 'store/form/inferentialStatistics/anova';
import { getActiveIndexTabAnova } from 'store/scenes/inferentialStatistics/selectors';
import {
  getVisibleNumericalSelectedParametersNames,
  getVisibleCategoricalSelectedParametersNames
} from 'store/dataset';

import { getOptionListForDropDown } from 'calculators/inferentialStatistics/oneSampleT';

import { round6 as round } from 'utilities/math';
import {
  makeFloatRangeValidator
} from 'utilities/validators.js';

import { getInfoForGroupRadioButtons } from './helpers';

const formatFn = value => (value || value === 0 ? round(value) : '');
const isValidateConfidenceInterval = makeFloatRangeValidator(0.0001, 99.9999);

const AnovaSettingFormComponent = ({ isFrequencyTable }) => {
  const numberOfGroups = useSelector(state => getNumberOfGroups(state));
  const activeIndexTabAnova = useSelector(state => getActiveIndexTabAnova(state));
  const numericalSelectedParametersNames = useSelector(state => getVisibleNumericalSelectedParametersNames(state));
  const categoricalSelectedParametersNames = useSelector(state => getVisibleCategoricalSelectedParametersNames(state));
  const isNumericalAndCategoricalChosen = useSelector(state => isNumericalAndCategoricalAnovaChosen(state));
  const isModeDatasetContainsRawData = useSelector(state => isAnovaModeDatasetContainsRawData(state));

  const numericalOptionsDataset = getOptionListForDropDown(
    { selectedParametersNames: numericalSelectedParametersNames,
      isFrequencyTable
    });
  const categoricalOptionsDataset = getOptionListForDropDown(
    { selectedParametersNames: categoricalSelectedParametersNames,
      isFrequencyTable
    });
  const isDatasetAvailable = numericalOptionsDataset.length > 0 && categoricalOptionsDataset.length > 0;

  const isSummaryDataTab = !activeIndexTabAnova || activeIndexTabAnova === 0;

  const isShowConfidenceInterval = activeIndexTabAnova !== 2;

  return (
    <>
      {
        isDatasetAvailable &&
        <RadioButtonsGroup
          labelGroupRadioButton="Dataset Contains"
          buttons={getInfoForGroupRadioButtons(!isSummaryDataTab)}
        />
      }
      {
        isDatasetAvailable && isModeDatasetContainsRawData
          ? (
            <AnovaRowData
              isSummaryDataTab={isSummaryDataTab}
              activeIndexTabAnova={activeIndexTabAnova}
              numericalOptionsDataset={numericalOptionsDataset}
              categoricalOptionsDataset={categoricalOptionsDataset}
              isNumericalAndCategoricalChosen={isNumericalAndCategoricalChosen}
            />
          )
          : (
            <AnovaSummaryStatistics
              isSummaryDataTab={isSummaryDataTab}
              isDatasetAvailable={isDatasetAvailable}
              isModeDatasetContainsRawData={isModeDatasetContainsRawData}
              numberOfGroups={numberOfGroups}
            />
          )
      }
      { isShowConfidenceInterval && (
        <>
          {activeIndexTabAnova === 1 && <p className="font-700 mb-5">Post Hoc Analysis</p>}
          <div className="flex baseline main-input--inline ml-10 mr-10">
            <Field
              type="number"
              id="anovaConfidenceInterval"
              component={Input}
              name="anovaConfidenceInterval"
              label="Confidence Interval"
              inputClassName="main-input__input ml-3 mt-20 max-85"
              labelClassName="main-input__label"
              wrapperClassName="relative flex baseline space-between iconTop width-full"
              pattern="\d+"
              format={formatFn}
              validate={isValidateConfidenceInterval}
              min={1}
              max={99}
            />
            <span className="main-input__label ml-10">%</span>
          </div>
        </>
      )}
    </>
  );
};


AnovaSettingFormComponent.propTypes = {
  isFrequencyTable: PropTypes.bool.isRequired
};

export default AnovaSettingFormComponent;
